import { SimpleLayout, useLayout } from '@approvalmax/ui/src/components';
import { Helmet } from 'react-helmet';

import { Success } from './resources/components';
import { useSlackAuthInstallPageData } from './resources/hooks';
import { messages } from './resources/messages';

const Page = () => {
    useLayout({ containerMinSize: 'xxsmall' });

    const { appDeepLink, onOpenSlack } = useSlackAuthInstallPageData();

    return (
        <SimpleLayout size='small'>
            <Helmet>
                <title>{messages.pageTitle}</title>
            </Helmet>

            {appDeepLink && (
                <SimpleLayout.Content>
                    <Success onOpenSlack={onOpenSlack} />
                </SimpleLayout.Content>
            )}
        </SimpleLayout>
    );
};

Page.displayName = 'Page';

export default Page;
